import React from 'react';
import Applicants from '../AdminDashboardPage/ApplicantsPage/Applicants';

function ApplicantsPage() {
  return (
    <div>
      <Applicants />
    </div>
  );
}

export default ApplicantsPage;
